import { ChevronRight, LucideIcon } from 'lucide-react';

interface ReportCardMobileProps {
  title: string;
  description: string;
  icon: LucideIcon;
  onClick: () => void;
}

export const ReportCardMobile = ({ title, description, icon: Icon, onClick }: ReportCardMobileProps): React.ReactNode => {
  return (
    <button
      onClick={onClick}
      className="w-full rounded-lg border border-input bg-background hover:bg-accent hover:text-accent-foreground transition-colors py-5 px-4 relative text-left"
    >
      {/* Chevron in top right corner */}
      <ChevronRight className="absolute top-4 right-4 h-5 w-5 text-muted-foreground" />

      {/* Content stacked vertically */}
      <div className="flex flex-col items-start gap-3 w-full pr-6">
        <Icon className="h-6 w-6" />

        <div className="space-y-1.5 w-full">
          <div className="font-semibold text-base">{title}</div>
          <div className="text-sm text-muted-foreground leading-relaxed">
            {description}
          </div>
        </div>
      </div>
    </button>
  );
};
